import React, { useEffect } from "react";
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import Sidebar from "../components/common/Sidebar/index";
import NotFound from "../components/notFound/notFound";
import Login from "../components/login";
import PresidentDetails from "../components/details/presidentDetails";
import SocietyDetails from "../components/details/societyDetails";
import DashboardComponent from "../components/dashboard/index";
import SocietiesComponent from "../components/societies/index";
import FinanceComponent from "../components/finance/index";
import { Cookies } from "react-cookie";
import ComingsoonPage from "../components/common/comingsoonPage";
import Complaints from "../components/details/complaintsPage";
import Setting from "../components/setting";
import ManageUsers from "../components/details/manageUser";
import Permissions from "../components/details/permissions";
import SocietyImages from "../components/details/societyImages";
import Unsubscribe from "../components/unsubscribe";
import UnRegisteredFlats  from "../components/details/toBeRegistered/index";

// President Dashboard Components
import PresidentDashboard from "../components/presidentDashboard/dashboard/index";
import PresidentSidebar from "../components/presidentDashboard/common/Sidebar/sidebar";
import UserList from "../components/presidentDashboard/details/manageUser/index";
import PresidentComplaints from "../components/presidentDashboard/details/complaintsPage/index";
import SocietyPermission from "../components/presidentDashboard/details/permissions/index";
import SocietyImagesPresident from "../components/presidentDashboard/details/societyImages/index";
import PresidentComingSoon from "../components/presidentDashboard/common/comingsoonPage/index";
import PresidentSetting from "../components/presidentDashboard/setting/index";
import ToBeRegistered from "../components/presidentDashboard/details/toBeRegistered/index";
import SheetApproval from "../components/presidentDashboard/details/sheetApproval/index";


const PrivateRoute = ({ children }) => {
  const cookies = new Cookies();
  const token = cookies.get("token");

  if (!token) {
    return <Navigate to="/" replace />;
  }

  try {
    const decodedToken = jwtDecode(token);
    const currentTime = Date.now() / 1000;
    if (decodedToken.exp < currentTime) {
      cookies.remove("token");
      return <Navigate to="/" replace />;
    }
  } catch (error) {
    cookies.remove("token");
    return <Navigate to="/" replace />;
  }

  return children;
};

const MainRoutes = () => {
  const SidebarHideArray = ["/", "/register", "/verify", "/unsubscribe"];
  const pendingRoutes = ["/finance"];
  const location = useLocation();
  const cookies = new Cookies();
  const token = cookies.get("token");
  const role = cookies.get("role");

  const navigate = useNavigate();

  useEffect(() => {
    if (!token && location.pathname !== "/unsubscribe") {
      navigate("/");
    } else if (token && location.pathname === "/") {
      navigate("/dashboard");
    }
  }, [token, location.pathname, navigate]);
  return (
    <>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/Unsubscribe" element={<Unsubscribe />} />
        <Route path="/login" element={<Navigate to="/" replace />} />
      </Routes>

      {role === "admin" && (
        <div className="main">
          {token && !SidebarHideArray.includes(window.location.pathname) && (
            <Sidebar />
          )}
          <div className="main_routes">
            <Routes>
              <Route
                path="/dashboard"
                element={
                  <PrivateRoute>
                    <DashboardComponent />
                  </PrivateRoute>
                }
              />
              <Route
                path="/society-list"
                element={
                  <PrivateRoute>
                    <SocietiesComponent />
                  </PrivateRoute>
                }
              />
              <Route
                path="/coming-soon"
                element={
                  <PrivateRoute>
                    <ComingsoonPage />
                  </PrivateRoute>
                }
              />
              {/* <Route
                path="/finance"
                element={
                  <PrivateRoute>
                    <FinanceComponent />
                  </PrivateRoute>
                }
              /> */}
              <Route
                path="/president-details"
                element={
                  <PrivateRoute>
                    <PresidentDetails />
                  </PrivateRoute>
                }
              />
              <Route
                path="/edit-president/:id"
                element={
                  <PrivateRoute>
                    <PresidentDetails />
                  </PrivateRoute>
                }
              />
                <Route
                path="/to-be-registered/:id"
                element={
                  <PrivateRoute>
                    <UnRegisteredFlats />
                  </PrivateRoute>
                }
              />
              <Route
                path="/society-details"
                element={
                  <PrivateRoute>
                    <SocietyDetails />
                  </PrivateRoute>
                }
              />
              <Route
                path="/edit-details/:id"
                element={
                  <PrivateRoute>
                    <SocietyDetails />
                  </PrivateRoute>
                }
              />
              <Route
                path="/help-desk"
                element={
                  <PrivateRoute>
                    <Complaints />
                  </PrivateRoute>
                }
              />
              <Route
                path="/manage-users/:id"
                element={
                  <PrivateRoute>
                    <ManageUsers />
                  </PrivateRoute>
                }
              />
              <Route
                path="/society-permissions/:id"
                element={
                  <PrivateRoute>
                    <Permissions />
                  </PrivateRoute>
                }
              />
              <Route
                path="/society-images/:id"
                element={
                  <PrivateRoute>
                    <SocietyImages />
                  </PrivateRoute>
                }
              />
              <Route
                path="/settings"
                element={
                  <PrivateRoute>
                    <Setting />
                  </PrivateRoute>
                }
              />
              {pendingRoutes.includes(location.pathname) ? (
                <Route path="*" element={<Navigate to="/coming-soon" />} />
              ) : (
                <>
                  <Route
                    path="/finance"
                    element={
                      <PrivateRoute>
                        <NotFound />
                      </PrivateRoute>
                    }
                  />
                </>
              )}
            </Routes>
          </div>
        </div>
      )}
      {role === "president" && (
        <div className="main">
          {token && !SidebarHideArray.includes(window.location.pathname) && (
            <PresidentSidebar />
          )}
          <div className="main_routes">
            <Routes>
              <Route
                path="/president-dashboard"
                element={
                  <PrivateRoute>
                    <PresidentDashboard />
                  </PrivateRoute>
                }
              />
              <Route
                path="/user-list"
                element={
                  <PrivateRoute>
                    <UserList />
                  </PrivateRoute>
                }
              />
              <Route
                path="/to-be-registered"
                element={
                  <PrivateRoute>
                    <ToBeRegistered />
                  </PrivateRoute>
                }
              />
              <Route
                path="/society-complaints"
                element={
                  <PrivateRoute>
                    <PresidentComplaints />
                  </PrivateRoute>
                }
              />
              <Route
                path="/society-permissions"
                element={
                  <PrivateRoute>
                    <SocietyPermission />
                  </PrivateRoute>
                }
              />
              <Route
                path="/society-images"
                element={
                  <PrivateRoute>
                    <SocietyImagesPresident />
                  </PrivateRoute>
                }
              />
              <Route
                path="/pre-approved-registration"
                element={
                  <PrivateRoute>
                    <SheetApproval />
                  </PrivateRoute>
                }
              />
              <Route
                path="/settings"
                element={
                  <PrivateRoute>
                    <PresidentSetting />
                  </PrivateRoute>
                }
              />
              <Route
                path="/finance"
                element={
                  <PrivateRoute>
                    <PresidentComingSoon />
                  </PrivateRoute>
                }
              />
            </Routes>
          </div>
        </div>
      )}
    </>
  );
};

export default MainRoutes;
